import * as Yup from 'yup'

export const createFeedbackSchema = (intl: any) =>
  Yup.object({
    // issueType: Yup.number().required(),
    message: Yup.string().required(intl.messages.YUP_VALIDATION_FEEDBACK_ADD_DESCR),
  })
